import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LocaleCode } from 'src/app/interfaces/locale'
import { LocaleService } from 'src/app/services/locale/locale-service'

@Component({
  selector: 'locale-name-input',
  templateUrl: './locale-name-input.component.html',
  styleUrls: ['./locale-name-input.component.scss'],
})
export class LocaleNameInput implements OnInit {
  constructor(private localeService: LocaleService) {}

  ngOnInit() {}

  @Input() lastName: string | undefined
  @Input() firstName: string | undefined
  @Input() lastNamePlaceholder: string | undefined
  @Input() firstNamePlaceholder: string | undefined
  @Output() firstNameChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() lastNameChange: EventEmitter<string> = new EventEmitter<string>()

  localeCode = LocaleCode
  locale$ = this.localeService.locale$

  onChangeValue(type: 'firstName' | 'lastName'): void {
    if (type === 'firstName') {
      this.firstNameChange.emit(this.firstName)
    } else {
      this.lastNameChange.emit(this.lastName)
    }
  }
}
